import { TEXTS } from '@/views/PesosCocidos/cookedWeightsConstants'
import { fillTemplate } from '@/views/PesosCocidos/textTemplate'

export function describeWeighingStep (ingredients) {
  if (ingredients.length === 0) {
    return `${TEXTS.STEP_WEIGH_GROUP} ${TEXTS.STEP_SPLIT_SINGLE}`
  }
  if (ingredients.length === 1) {
    return `${TEXTS.STEP_WEIGH_PREFIX} ${ingredients[0].ingredient_name} ${TEXTS.STEP_WEIGH_SINGLE_SUFFIX} ${TEXTS.STEP_SPLIT_SINGLE}`
  }
  return `${TEXTS.STEP_WEIGH_MIX_PREFIX} ${ingredients.length} ${TEXTS.STEP_WEIGH_MIX_SUFFIX} ${TEXTS.STEP_SPLIT_MIX}`
}

function joinNames (names) {
  if (names.length <= 1) {
    return names.join('')
  }
  return `${names.slice(0, -1).join(TEXTS.LIST_SEPARATOR)}${TEXTS.LIST_LAST_SEPARATOR}${names[names.length - 1]}`
}

export function describePendingGroups (groups) {
  if (groups.length === 0) {
    return ''
  }
  return fillTemplate(TEXTS.PENDING_GROUPS, { groups: groups.map((group) => group.subgroup_name).join(TEXTS.LIST_SEPARATOR) })
}

export function describeZeroWeightGroups (groups) {
  if (groups.length === 0) {
    return ''
  }
  const names = joinNames(groups.map((group) => group.subgroup_name))
  const rule = groups.length === 1 ? TEXTS.ZERO_GROUP_SINGULAR_RULE : TEXTS.ZERO_GROUP_PLURAL_RULE
  return `${names} ${rule}`
}
